import React, { useRef, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const UpcomingPaymentsCard = () => {
  const upcomingPaymentsData = [
    { id: 1, amount: "1.2 Mn IDR", description: "WC Loan Payment Due", dueDate: "31-08-2025" },
    { id: 2, amount: "850 K IDR", description: "Car Loan Payment Due", dueDate: "15-09-2025" },
    { id: 3, amount: "2.5 Mn IDR", description: "Home Loan Payment Due", dueDate: "01-10-2025" },
    { id: 4, amount: "600 K IDR", description: "Personal Loan Payment Due", dueDate: "20-10-2025" },
  ];

  // Create separate refs for navigation buttons
  const prevBtnRef = useRef(null);
  const nextBtnRef = useRef(null);

  useEffect(() => {
    // Attach navigation refs directly to Swiper instance
    if (prevBtnRef.current && nextBtnRef.current) {
      const swiperInstance = document.querySelector(".swiper").swiper;
      if (swiperInstance) {
        swiperInstance.params.navigation.prevEl = prevBtnRef.current;
        swiperInstance.params.navigation.nextEl = nextBtnRef.current;
        swiperInstance.navigation.update();
      }
    }
  }, []);

  const handleView = () => {
    //console.log("View details clicked");
  };

  return (
    <Box
      className="rounded-md py-2 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh",
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-main font-bold text-left text-xs">
          Upcoming Payments
        </div>
        <IconButton
          aria-label="view"
          onClick={handleView}
          sx={{ height: 24, width: 24 }}
        >
          <ArrowForwardOutlinedIcon />
        </IconButton>
      </div>

      <Box className="flex items-center gap-2 justify-between">
        {/* Navigation Buttons */}
        <IconButton ref={prevBtnRef}>
          <ArrowBackIosNewIcon sx={{ fontSize: 14 }} color="primary" />
        </IconButton>
        {/* Swiper Carousel */}
        <Swiper
          className="swiper"
          modules={[Navigation]}
          spaceBetween={10}
          slidesPerView={1}
          // onSwiper={(swiper) => {
          //   // Attach navigation dynamically when Swiper initializes
          //   swiper.params.navigation.prevEl = prevBtnRef.current;
          //   swiper.params.navigation.nextEl = nextBtnRef.current;
          //   swiper.navigation.update();
          // }}
          navigation={{
            prevEl: prevBtnRef.current,
            nextEl: nextBtnRef.current,
          }}
         onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevBtnRef.current;
              swiper.params.navigation.nextEl = nextBtnRef.current;
         }}
        >
          {upcomingPaymentsData.map((item) => (
            <SwiperSlide key={item.id}>
              <Box className="flex flex-col gap-1 justify-center items-center">
                <div className="text-main font-bold text-[12px] text-center">
                  {item.amount}
                </div>
                <div className="text-gray-600 text-[10px] text-center font-bold">
                  {item.description}
                </div>
                <div className="text-gray-600 text-[10px] text-center">
                  <i>Due Date: {item.dueDate}</i>
                </div>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Navigation Buttons */}
        <IconButton ref={nextBtnRef}>
          <ArrowForwardIosIcon sx={{ fontSize: 14 }} color="primary" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default UpcomingPaymentsCard;
